import cancellationReducer from '../features/cancellation/redux/reducer';
import { combineReducers } from 'redux';
import commonReducer from '../features/common/redux/reducer';
import enRoutesReducer from '../features/en-routes/redux/reducer';
import esRoutesReducer from '../features/es-routes/redux/reducer';
import examplesReducer from '../features/examples/redux/reducer';
import homeReducer from '../features/home/redux/reducer';
import myAccountReducer from '../features/my-account/redux/reducer';
import pagesReducer from '../features/pages/redux/reducer';
import pbPaymentDetailsReducer from '../features/Pasajebus/PasajebusPaymentDetails/redux/reducer';
import pbServiceListReducer from '../features/Pasajebus/PasajebusServiceList/redux/reducer';
import { routerReducer } from 'react-router-redux';
import siteMapReducer from '../features/site-map/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  examples: examplesReducer,
  pbServiceList: pbServiceListReducer,
  pbPaymentDetails: pbPaymentDetailsReducer,
  myAccount: myAccountReducer,
  cancellation: cancellationReducer,
  pages: pagesReducer,
  siteMap: siteMapReducer,
  esRoutes: esRoutesReducer,
  enRoutes: enRoutesReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js